import { CalendarCheck, MessageSquare, ShieldCheck } from "lucide-react";
import Seo from "@/components/Seo";
import Booking from "@/components/Booking";
import { FadeUp, Eyebrow } from "@/lib/motion";

const EXPECT = [
  {
    icon: MessageSquare,
    title: "Direct time with Todd",
    body: "Not a sales rep, not a form funnel — the person who would actually run your account is on the call.",
  },
  {
    icon: CalendarCheck,
    title: "A plain-language read",
    body: "We look at your website, rankings, and advertising together and tell you exactly where the gaps are.",
  },
  {
    icon: ShieldCheck,
    title: "An honest yes or no",
    body: "If we can help, we'll show you how. If we can't, we'll say so — and point you somewhere that can.",
  },
];

export default function StrategyCallPage() {
  return (
    <main data-testid="strategy-call-page" className="grain relative">
      <Seo
        title="Free Strategy Call — ZD Design"
        description="Book a free 30-minute strategy call with Todd: a plain-language read on your website, SEO and advertising — and an honest yes-or-no on whether we can help."
        path="/free-strategy-call"
      />
      <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#F8F9FA] to-[#F1F3F5] pb-16 pt-36 sm:pt-44">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
          <FadeUp>
            <Eyebrow>Free strategy call</Eyebrow>
            <h1 className="mt-5 max-w-3xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-slate-900 sm:text-6xl">
              Thirty minutes with Todd.{" "}
              <span className="text-flame">No obligation.</span>
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-mist sm:text-xl">
              Tell us where your website, SEO, and advertising fall short.
              You'll leave the call with a plain-language read on your gaps —
              and an honest yes-or-no on whether we can help.
            </p>
          </FadeUp>
          <div className="mt-12 grid gap-5 md:grid-cols-3">
            {EXPECT.map((e, i) => (
              <FadeUp key={e.title} delay={i * 0.1} className="h-full">
                <div className="h-full rounded-2xl border border-slate-200 bg-white shadow-sm p-6">
                  <e.icon className="h-5 w-5 text-flame" aria-hidden="true" />
                  <div className="mt-4 font-display text-xl font-bold text-slate-900">
                    {e.title}
                  </div>
                  <p className="mt-2 text-base leading-relaxed text-mist">
                    {e.body}
                  </p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
      <Booking highLevel />
    </main>
  );
}
